@if (layout === 'empty') {
    <empty-layout></empty-layout>
}


@if (layout === 'futuristic') {
    <futuristic-layout></futuristic-layout>
}
